export default __webpack_public_path__ + "static/media/chia-scaled.469f382d.jpg";